export const SERVICE_CAPS = [
    {
        label: 'نمایش در منو',
        name: 'showInMenu',
        color: '',
    },
    {
        label: 'لیست خبرها در صفحه اصلی',
        name: 'listInHome',
        color: '',
    },
    {
        label: 'سرویس میان خبر',
        name: 'inlineNews',
        color: '',
    },
    {
        label: 'جایگاه شناور',
        name: 'floatingNews',
        color: '',
    },
    {
        label: 'rss',
        name: 'rss',
        color: '',
    },
    {
        label: 'sitemap',
        name: 'sitemap',
        color: '',
    },
]
